import { render } from "./MyProfilePage.vue?vue&type=template&id=c5be75b8&ts=true"
import script from "./MyProfilePage.vue?vue&type=script&lang=ts"
export * from "./MyProfilePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Settings/MyProfilePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5be75b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5be75b8', __exports__)) {
    api.reload('c5be75b8', __exports__)
  }
  
  module.hot.accept("./MyProfilePage.vue?vue&type=template&id=c5be75b8&ts=true", () => {
    api.rerender('c5be75b8', render)
  })

}


export default __exports__